import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["functionalareaSelect", "positionSelect", "tagSelect"]

  connect() {
    // Wenn beim Laden (Edit) bereits eine FA ID vorhanden ist, laden wir die Daten
    if (this.functionalareaSelectTarget.value) {
      this.loadOptions(true) // true = Initialer Modus
    }
  }

  updateFunctionalarea() {
    // Wenn der User die FA ändert, löschen wir die gespeicherten IDs im Dataset,
    // damit nicht fälschlicherweise eine alte Position selektiert wird
    this.positionSelectTarget.dataset.selectedId = ""
    this.tagSelectTarget.dataset.selectedId = ""
    
    this.loadOptions(false)
  }

  async loadOptions(isInitial = false) {
    const faId = this.functionalareaSelectTarget.value
    if (!faId) return

    try {
      const response = await fetch(`/functionalareas/${faId}/dependent_options`)
      if (!response.ok) throw new Error("Fetch failed")
      const data = await response.json()

      // Wir holen die ID entweder aus dem Select-Value (New) oder dem Dataset (Edit)
      const posId = isInitial ? this.positionSelectTarget.dataset.selectedId : ""
      const tagId = isInitial ? this.tagSelectTarget.dataset.selectedId : ""

      this.populateSelect(this.positionSelectTarget, data.positioncategories, "Position wählen", posId)
      this.populateSelect(this.tagSelectTarget, data.tags, "Tag wählen", tagId)
      
    } catch (error) {
      console.error("Fehler beim Laden:", error)
    }
  }

  populateSelect(select, items, promptText, selectedId) {
    select.innerHTML = `<option value="">${promptText}</option>`

    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      // Nutze label oder fallbacks wie im JSON definiert
      option.textContent = item.label || item.positioncategory || item.description
      
      // Vergleich: Entweder die übergebene ID (Edit) oder der aktuelle Wert
      if (selectedId && item.id.toString() === selectedId.toString()) {
        option.selected = true
      }

      select.appendChild(option)
    })
  }
}